import { useLocation } from 'react-router-dom';
import { BthLogo } from '../brand/BthLogo';
import { portalKindFromPath } from '../../lib/portal';

export function LoginBrand() {
  const { pathname } = useLocation();
  const kind = portalKindFromPath(pathname);
  const isPortalHub =
    pathname === '/choose-portal' || pathname === '/login' || pathname.startsWith('/auth/');

  return (
    <div className="login-brand">
      <BthLogo className="login-brand__logo" />
      <h1 className="login-brand__title">
        {isPortalHub ? (
          <span className="login-brand__title-inline">
            <span className="login-brand__title-word">BTH</span>
            <span className="login-brand__title-sep" aria-hidden>
              ·
            </span>
            <span className="login-brand__title-word login-brand__title-word--accent">Portal</span>
          </span>
        ) : kind === 'it' ? (
          <>
            <span className="login-brand__title-line">IT</span>
            <span className="login-brand__title-line">Management</span>
          </>
        ) : (
          <>
            <span className="login-brand__title-line">Customer Relationship</span>
            <span className="login-brand__title-line">Management</span>
          </>
        )}
      </h1>
    </div>
  );
}
